import React from 'react';
import { useTranslation } from 'react-i18next';
import Breadcrumb from '../components/Breadcrumb';
import { ReconciliationTab } from './UsageSummary';

// 平台对账独立页:复用 UsageSummary 中的 ReconciliationTab(月度/区间对账)。
const PlatformReconciliation: React.FC = () => {
  const { t } = useTranslation('profile');
  return (
    <div className="container">
      <Breadcrumb items={[
        { label: t('usageSummary.breadcrumbProjects'), to: '/projects' },
        { label: t('usageSummary.tabReconciliation') },
      ]} />

      <div className="page-header">
        <h1 className="page-title">{t('usageSummary.tabReconciliation')}</h1>
      </div>

      <ReconciliationTab />
    </div>
  );
};

export default PlatformReconciliation;
